import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { useUnreadMessagesCount } from '@/hooks/useUnreadMessagesCount';
import { useNotifications } from '@/contexts/NotificationsContext';

interface BadgesContextValue {
  messagesCount: number;
  notificationsCount: number;
  loading: boolean;
}

const BadgesContext = createContext<BadgesContextValue | undefined>(undefined);

export const BadgesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const messagesCount = useUnreadMessagesCount();
  const { unreadCount: notificationsCount, loading: notificationsLoading } = useNotifications();

  const value = useMemo(() => ({
    messagesCount: typeof messagesCount === 'number' ? messagesCount : 0,
    notificationsCount: typeof notificationsCount === 'number' ? notificationsCount : 0,
    loading: notificationsLoading
  }), [messagesCount, notificationsCount, notificationsLoading]);

  return (
    <BadgesContext.Provider value={value}>
      {children}
    </BadgesContext.Provider>
  );
};

export const useBadges = () => {
  const context = useContext(BadgesContext);
  if (!context) {
    throw new Error('useBadges must be used within BadgesProvider');
  }
  return context;
};
